import React from 'react'
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title'

const ActivityWrapper = ({ children, route }) => {
  return (
    <DocumentTitle title={ route.title }>
      { children }
    </DocumentTitle>
  )
}
ActivityWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  route: PropTypes.object.isRequired,
}

export default ActivityWrapper
